import Vue from "vue";

const getFilesList = (page_id = 1) =>
  Vue.prototype.$http.get("file/?page=" + page_id).then((response) => {
    return response.data;
  });

export { getFilesList };
